import { Component, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-developer',
  templateUrl: './developer.component.html',
  styleUrls: ['./developer.component.css']
})
export class DeveloperComponent {
  developerData: any[] = []; // Ensure to type this appropriately
  constructor(
    public shared: SharedService, 
    private elRef: ElementRef, 
    private renderer: Renderer2, 
    public apiService: ApiServiceService,
    public route: ActivatedRoute
  ) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    this.getData();
  }

  async getData() {
    const res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_DEVELOPER, {});
    if (res && !res.error && res.data) {
      this.developerData = res.data; // Assuming res.data is an array of developers
    }
  }

  redirectProperty(developer_id: number) {
    window.location.href = "/developer-view/" + developer_id;
  }
}
